module.exports = __webpack_public_path__ + "assets/img/rjs2.5dea5c75.png";